<template>
  <div class="page-container">
	<v-toolbar color="secondary" dark class="headline">
    	<v-toolbar-title>Razas</v-toolbar-title>
	</v-toolbar>
	<v-container fluid>
        <v-layout row wrap>
			<v-flex xs12 sm4 pa-1 v-for="raza in razas" :key="raza.id">
				<v-card>
				<v-container fluid grid-list-lg>
					<v-layout row wrap>
					<v-flex xs12>
						<div v-if="raza.editando!=true" class="headline razas-titulo" >{{raza.descripcion}}</div>
						<v-text-field :id="'txtRaza' + raza.id" class="headline input-razas"  v-if="raza.editando==true" v-model="raza.descripcion"></v-text-field>
						<v-card-actions style="padding:0px;margin-top: 10px;justify-content:flex-end">
							<v-btn fab v-if="raza.editando==true" style="margin-right:10px!important" color="red" dark @click="cancelar(raza)"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
							<v-btn fab v-if="raza.editando==true" color="green" dark @click="aceptar(raza)"><v-icon class="fa-fab-icon">fa-check</v-icon></v-btn>
							<v-btn fab v-if="raza.editando!=true" style="margin-right:10px!important" :disabled="editando" color="red" dark @click="confirmarEliminar(raza)"><v-icon class="fa-fab-icon">fa-trash</v-icon></v-btn>
							<v-btn fab v-if="raza.editando!=true" :disabled="editando" color="blue" dark @click="setEditando(raza)"><v-icon class="fa-fab-icon">fa-pen</v-icon></v-btn>
						</v-card-actions>
					</v-flex>
					</v-layout>
				</v-container>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
	<v-btn color="green" :disabled="editando" dark fixed bottom right class="btn-very-large" @click="agregarNuevo()" fab>
		<v-icon>add</v-icon>
    </v-btn>
	<v-snackbar top :color="snackRaza" v-model="snackbar">{{ mensaje }}<v-btn color="black" small fab dark @click="snackbar = false"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
    </v-snackbar>
	<v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar Raza</span>
        </v-card-title>
        <v-card-text>
			¿Estás seguro que querés eliminar la raza?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="onCancelarEliminar()">No</v-btn>
          <v-btn color="blue darken-1" dark @click="onConfirmarEliminar()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  	<div style="height:80px;width:1px;" v-if="$vuetify.breakpoint.smAndDown">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: "razas",
  components: {},
  data() {
    return { razas: [],snackbar:false,mensaje:'',snackRaza:'success',editando:false,dialog:false,aEliminar:null};
  },
  created() {
    this.obtenerElementos();
  },
  methods: {
    obtenerElementos: function() {
		this.$http.get(this.$root.mainUrl + 'api/razas.php').then(result => {
			result.json().then(elem =>{
				this.razas = elem;
				for(let i=0;i<this.razas.length;i++){
					this.$set(this.razas[i], 'editando', false);
				}
      		});
      	}, error => {
			//   console.error(error);
			this.showMessage('Ocurrió un error al obtener las razas','error');
      	});
	},
	setEditando: function(raza){
		raza.descripcionBack = raza.descripcion;
		raza.editando = true;
		this.editando = true;
		this.$nextTick(() => document.getElementById('txtRaza' + raza.id).focus());
	},
	cancelar: function(raza){
		raza.descripcion = raza.descripcionBack;
		raza.editando = false;
		this.editando = false;
		if (raza.id==null){
			this.razas.pop();
		}
	},
	confirmarEliminar: function(raza){
		this.aEliminar = raza;
		this.dialog = true;
	},
	onConfirmarEliminar: function(){
		this.dialog = false;
		this.eliminar(this.aEliminar);
	},
	onCancelarEliminar: function(){
		this.dialog = false;
		this.aEliminar = null;
	},
	eliminar: function(raza){
		raza.operacion = "ELIMINAR";
		this.$http.post(this.$root.mainUrl + 'api/razas.php',raza).then(result => {
			result.json().then(elem =>{
				let idx=this.getIndex(raza);
				this.razas.splice(idx, 1);
				this.snackbar = true;
				this.mensaje = "Raza eliminada correctamente";
				this.aEliminar = null;
			});
		}, error => {
			this.showMessage('Ocurrió un error al eliminar la raza','error');
			// console.error(error);
		});
	},
	aceptar: function(raza){
		if (raza.descripcion==null || raza.descripcion.trim()==''){
			this.showMessage('La descripción no puede estar vacía','error');
			return;
		}
		raza.descripcionBack = null;
		raza.editando = false;
		raza.operacion = "GUARDAR";
		this.$http.post(this.$root.mainUrl + 'api/razas.php',raza).then(result => {
			result.json().then(elem =>{
				if (elem.id!=null){
					raza.id=elem.id;
					this.showMessage('Raza creada correctamente','success');
				}
				else{
					this.showMessage('Raza actualizada correctamente','success');
				}
				this.editando = false;
			});
		}, error => {
			this.showMessage('Ocurrió un error al actualizar la Raza','error');
			// console.error(error);
		});
	},
	agregarNuevo: function(){
		this.editando = true;
		let raza = {editando:true,descripcion:'',id:null};
		this.razas.push(raza);
		this.$vuetify.goTo(5000);
	},
	getIndex: function(raza){
		for (let i=0;i<this.razas.length;i++){
			if (this.razas[i].id==raza.id){
				return i;
			}
		}
		return -1;
	},
	showMessage: function(message,style){
		this.snackRaza = style;
		this.mensaje = message;
		this.snackbar = true;
	}
  }
};
</script>
<style>
.page-container{
	padding-top:60px;
}
.fa-fab-icon{
	font-size: 1.5em!important;
}
.btn-very-large{
	height: 66px!important;
	width: 66px!important;
}
.btn-very-large i{
	font-size: 3.5em!important;
}
.razas-titulo{
	min-height:40px;
}
.input-razas{
	padding-top: 0px!important;
	padding-bottom: 0px!important;
	margin-top: 0px!important;
	margin-bottom: 0px!important;
}
.input-razas .v-text-field__details{
	display: none;
}
</style>
